import { BASE_URL } from '../components/AppConfig';
import { handleDynamicRequest } from '../components/DyanamicRequest';

// Ad Users API
export const adUsersApi = {
  getAll: async () => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'GET',
        `${BASE_URL}/sponsored-ads/users`,
        null,
        () => resolve({ statusCode: "50000", message: 'Failed to fetch users' }),
        (response) => resolve(response)
      );
    });
  },

  getById: async (id) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'GET',
        `${BASE_URL}/sponsored-ads/users/${id}`,
        null,
        () => resolve({ statusCode: "50000", message: 'Failed to fetch user' }),
        (response) => resolve(response)
      );
    });
  },

  create: async (data) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'POST',
        `${BASE_URL}/sponsored-ads/users`,
        data,
        () => resolve({ statusCode: "50000", message: 'Failed to create user' }),
        (response) => resolve(response)
      );
    });
  },

  update: async (id, data) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'PUT',
        `${BASE_URL}/sponsored-ads/users/${id}`,
        data,
        () => resolve({ statusCode: "50000", message: 'Failed to update user' }),
        (response) => resolve(response)
      );
    });
  },

  delete: async (id) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'DELETE',
        `${BASE_URL}/sponsored-ads/users/${id}`,
        null,
        () => resolve({ statusCode: "50000", message: 'Failed to delete user' }),
        (response) => resolve(response)
      );
    });
  }
};

// Ad Sets API
export const adSetsApi = {
  getAll: async () => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'GET',
        `${BASE_URL}/sponsored-ads/adsets`,
        null,
        () => resolve({ statusCode: "50000", message: 'Failed to fetch ad sets' }),
        (response) => resolve({ statusCode: "10000", message: "Ad sets retrieved successfully", data: response.data || [] })
      );
    });
  },

  getById: async (id) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'GET',
        `${BASE_URL}/sponsored-ads/adsets/${id}`,
        null,
        () => resolve({ statusCode: "50000", message: 'Failed to fetch ad set' }),
        (response) => resolve(response)
      );
    });
  },

  getAdsByAdSetId: async (id) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'GET',
        `${BASE_URL}/sponsored-ads/adsets/${id}/ads`,
        null,
        () => resolve({ statusCode: "50000", message: 'Failed to fetch ads for ad set' }),
        (response) => resolve({ statusCode: "10000", message: "Ads retrieved successfully", data: response.data || [] })
      );
    });
  },

  create: async (data) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'POST',
        `${BASE_URL}/sponsored-ads/adsets`,
        data,
        () => resolve({ statusCode: "50000", message: 'Failed to create ad set' }),
        (response) => resolve(response)
      );
    });
  },

  update: async (id, data) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'PUT',
        `${BASE_URL}/sponsored-ads/adsets/${id}`,
        data,
        () => resolve({ statusCode: "50000", message: 'Failed to update ad set' }),
        (response) => resolve(response)
      );
    });
  },

  delete: async (id) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'DELETE',
        `${BASE_URL}/sponsored-ads/adsets/${id}`,
        undefined,
        () => resolve({ statusCode: "50000", message: 'Failed to delete ad set' }),
        (response) => resolve(response)
      );
    });
  }
};

// Ads API
export const adsApi = {
  getAll: async () => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'GET',
        `${BASE_URL}/sponsored-ads/ads`,
        null,
        () => resolve({ statusCode: "50000", message: 'Failed to fetch ads' }),
        (response) => resolve(response)
      );
    });
  },

  getById: async (id) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'GET',
        `${BASE_URL}/sponsored-ads/ads/${id}`,
        null,
        () => resolve({ statusCode: "50000", message: 'Failed to fetch ad' }),
        (response) => resolve(response)
      );
    });
  },

  create: async (data) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'POST',
        `${BASE_URL}/sponsored-ads/ads`,
        data,
        () => resolve({ statusCode: "50000", message: 'Failed to create ad' }),
        (response) => resolve(response)
      );
    });
  },

  update: async (id, data) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'PUT',
        `${BASE_URL}/sponsored-ads/ads/${id}`,
        data,
        () => resolve({ statusCode: "50000", message: 'Failed to update ad' }),
        (response) => resolve(response)
      );
    });
  },

  delete: async (id) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'DELETE',
        `${BASE_URL}/sponsored-ads/ads/${id}`,
        undefined,
        () => resolve({ statusCode: "50000", message: 'Failed to delete ad' }),
        (response) => resolve(response)
      );
    });
  }
};

// Campaigns API
export const campaignsApi = {
  getAll: async () => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'GET',
        `${BASE_URL}/sponsored-ads/campaigns`,
        null,
        () => resolve({ statusCode: "50000", message: 'Failed to fetch campaigns' }),
        (response) => resolve(response)
      );
    });
  },

  getById: async (id) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'GET',
        `${BASE_URL}/sponsored-ads/campaigns/${id}`,
        null,
        () => resolve({ success: false, error: 'Failed to fetch campaign' }),
        (data) => resolve({ success: true, data })
      );
    });
  },

  create: async (data) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'POST',
        `${BASE_URL}/sponsored-ads/campaigns`,
        data,
        () => resolve({ success: false, error: 'Failed to create campaign' }),
        (data) => resolve({ success: true, data })
      );
    });
  },

  createWithAdSets: async (data) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'POST',
        `${BASE_URL}/sponsored-ads/campaigns/with-adsets`,
        data,
        () => resolve({ success: false, error: 'Failed to create campaign with ad sets' }),
        (data) => resolve({ success: true, data })
      );
    });
  },

  update: async (id, data) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'PUT',
        `${BASE_URL}/sponsored-ads/campaigns/${id}`,
        data,
        () => resolve({ success: false, error: 'Failed to update campaign' }),
        (data) => resolve({ success: true, data })
      );
    });
  },

  delete: async (id) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'DELETE',
        `${BASE_URL}/sponsored-ads/campaigns/${id}`,
        undefined,
        () => resolve({ statusCode: "50000", message: 'Failed to delete campaign' }),
        (response) => resolve(response)
      );
    });
  }
};

// Campaign Ad Sets API
export const campaignAdSetsApi = {
  addAdSet: async (campaignId, data) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'POST',
        `${BASE_URL}/sponsored-ads/campaigns/${campaignId}/ad-sets`,
        data,
        () => resolve({ success: false, error: 'Failed to add ad set to campaign' }),
        (data) => resolve({ success: true, data })
      );
    });
  },

  updateAdSet: async (campaignId, adSetId, data) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'PUT',
        `${BASE_URL}/sponsored-ads/campaigns/${campaignId}/ad-sets/${adSetId}`,
        data,
        () => resolve({ success: false, error: 'Failed to update ad set in campaign' }),
        (data) => resolve({ success: true, data })
      );
    });
  },

  removeAdSet: async (campaignId, adSetId) => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'DELETE',
        `${BASE_URL}/sponsored-ads/campaigns/${campaignId}/ad-sets/${adSetId}`,
        null,
        () => resolve({ success: false, error: 'Failed to remove ad set from campaign' }),
        (data) => resolve({ success: true, data })
      );
    });
  }
};

export const competitionsApi = {
  getAll: async () => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'GET',
        `${BASE_URL}/competitions`,
        { limit: 1000, offset: 0 },
        () => resolve({ statusCode: "50000", message: 'Failed to fetch competitions' }),
        (response) => resolve(response)
      );
    });
  }
};

// Dashboard API
// Feed ad placements & analytics
export const feedAdsApi = {
  getPlacements: async () => {
    return new Promise((resolve) => {
      handleDynamicRequest(
        'GET',
        `${BASE_URL}/sponsored-ads/feed-ad-placements`,
        null,
        () => resolve({ statusCode: '50000', message: 'Failed to fetch feed ad placements' }),
        (response) => resolve(response)
      );
    });
  }
};

export const analyticsApi = {
  getPlacementAnalytics: async ({ campaignId, startDate, endDate } = {}) => {
    const queryParams = new URLSearchParams();
    if (campaignId) queryParams.append('campaignId', String(campaignId));
    if (startDate) queryParams.append('startDate', startDate);
    if (endDate) queryParams.append('endDate', endDate);

    const url = `${BASE_URL}/sponsored-ads/analytics/placements${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

    return new Promise((resolve) => {
      handleDynamicRequest(
        'GET',
        url,
        null,
        () => resolve({ statusCode: '50000', message: 'Failed to fetch placement analytics' }),
        (response) => resolve(response)
      );
    });
  }
};

export const dashboardApi = {
  getHierarchicalSummary: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.campaignId) queryParams.append('campaignId', params.campaignId);
    if (params.adSetId) queryParams.append('adSetId', params.adSetId);

    const url = `${BASE_URL}/sponsored-ads/dashboard/hierarchical${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

    return new Promise((resolve) => {
      handleDynamicRequest(
        'GET',
        url,
        null,
        () => resolve({ statusCode: "50000", message: 'Failed to fetch hierarchical dashboard summary' }),
        (response) => resolve(response)
      );
    });
  },

  getCampaignAnalytics: async (campaignId, params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);

    const url = `${BASE_URL}/sponsored-ads/dashboard/campaigns/${campaignId}/hierarchical${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

    return new Promise((resolve) => {
      handleDynamicRequest(
        'GET',
        url,
        null,
        () => resolve({ statusCode: "50000", message: 'Failed to fetch campaign analytics' }),
        (response) => resolve(response)
      );
    });
  }
}; 